module.exports = __webpack_public_path__ + "static/media/robot.cfc4ef34.svg";